import { render, staticRenderFns } from "./SubmissionListing.vue?vue&type=template&id=5a7ad6d0&"
import script from "./SubmissionListing.vue?vue&type=script&lang=js&"
export * from "./SubmissionListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports